<form [formGroup]="localidadForm">
    <div class="row">
        <div class="col-lg-6">
            <mat-form-field>
                <ngx-spinner [zIndex]="1" name="spProvincia" bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
                <mat-label>Provincia</mat-label>
                <input matInput placeholder="Provincia" formControlName="Provincia" [matAutocomplete]="autoPronvicia" />
                <mat-icon matSuffix>search</mat-icon>
                <mat-error *ngIf="f.Provincia.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
                <mat-hint>Habilita localidades.</mat-hint>
            </mat-form-field>
            <!-- Antes tenía (click) y (onSelectionChange) a la vez: cada elección
                 disparaba dos veces la consulta de localidades -->
            <mat-autocomplete #autoPronvicia="matAutocomplete">
                <mat-option *ngFor="let provincia of filteredProvincia | async;let i=index;trackBy:trackByItems"
                    [value]="provincia.descripcion" (onSelectionChange)="$event.isUserInput && seleccionarProvincia(provincia)">
                    <div>{{provincia.descripcion | titlecase}}</div>
                </mat-option>
            </mat-autocomplete>

        </div>
        <div class="col-lg-6">
            <mat-form-field>
                <ngx-spinner [zIndex]="1" name="spLocalidades" bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
                <mat-label>Localidad</mat-label>
                <!-- blur valida lo tipeado: si no coincide con ninguna localidad
                     real, se avisa al padre para que no guarde un id viejo -->
                <input matInput typehead placeholder="Localidad" formControlName="Localidad"
                    (blur)="validarTextoLocalidad()" [matAutocomplete]="autoLocalidad" />
                <mat-icon matSuffix>search</mat-icon>
                <mat-error *ngIf="f.Localidad.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
            </mat-form-field>
            <mat-autocomplete #autoLocalidad="matAutocomplete">
                <mat-option *ngFor="let item of filteredLocalidades | async;let i=index;trackBy:trackByItems"
                    [value]="item.descripcion" (onSelectionChange)="$event.isUserInput && seleccionarLocalidad(item)">
                    <div>{{item.descripcion | titlecase}}</div>
                </mat-option>
            </mat-autocomplete>
        </div>
    </div>
</form>
